import React from "react"

// =============================================================================
// Props
// =============================================================================

export type StepperFooterProps = {
  /** Free-form footer content, e.g. Button or LinkButton actions */
  children?: React.ReactNode
}

// =============================================================================
// Component
// =============================================================================

/**
 * An optional row of actions below the stepper's list of steps.
 */
export function StepperFooter({ children }: StepperFooterProps) {
  return (
    <div
      data-slot="stepper-footer"
      className="mt-6 flex flex-wrap items-start gap-2"
    >
      {children}
    </div>
  )
}

StepperFooter.displayName = "Stepper.Footer"
